const YOUTUBE_ORIGIN = 'https://www.youtube-nocookie.com';

export const buildYouTubeEmbedUrl = (videoId, pageOrigin = '') => {
  const params = new URLSearchParams({ autoplay: '1', rel: '0', enablejsapi: '1' });
  if (pageOrigin) params.set('origin', pageOrigin);
  return `${YOUTUBE_ORIGIN}/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
};

export const buildYouTubePlayerCommand = (command) =>
  JSON.stringify({ event: 'command', func: command, args: [] });

const createVideoIframe = (videoId, title) => {
  const iframe = document.createElement('iframe');
  iframe.src = buildYouTubeEmbedUrl(videoId, window.location.origin);
  iframe.title = title;
  iframe.loading = 'lazy';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  iframe.allowFullscreen = true;
  return iframe;
};

export const playVideo = (section) => {
  const video = section.querySelector('.js-product-walkthrough-video');
  if (!video) return;

  const currentPlayer = video.querySelector('iframe');
  if (currentPlayer) {
    currentPlayer.contentWindow?.postMessage(buildYouTubePlayerCommand('playVideo'), YOUTUBE_ORIGIN);
    return;
  }

  const iframe = createVideoIframe(video.dataset.videoId, video.dataset.videoTitle);
  video.replaceChildren(iframe);
};

export default function productWalkthrough () {
  document.querySelectorAll('.product-walkthrough').forEach((section) => {
    section.querySelectorAll('.js-product-walkthrough-play').forEach((button) => {
      button.addEventListener('click', () => playVideo(section));
    });
  });
}
